
const Hero = () => {
  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[700px] flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/3ce37778a322554914e024051b29af27/1f775f02cdeea667be1ea5ad2dfdb072.png"
          alt="Healthcare services"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A2647]/90 via-[#0A2647]/70 to-[#0A2647]/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-32">
        <div className="max-w-2xl">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Healthcare That's Right For You
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Personalized private health insurance solutions tailored to your unique needs. 
            Whether you're an individual, family, or small business in Austin, we'll help you 
            find the perfect coverage.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={scrollToServices}
              className="inline-flex items-center justify-center gap-2 bg-[#2196F3] hover:bg-[#1976D2] text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Learn More
              <i className="ri-arrow-down-line"></i>
            </button>
            <a
              href="tel:512-306-6245"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white border border-white/30 px-8 py-4 rounded-lg font-semibold text-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill"></i>
              Call Us Today
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
